export default {"src":"/_next/static/media/unified-communication-systems.271dd3d0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};